export const Session = {
  save:  (s)  => { try { localStorage.setItem("bloom:sess", JSON.stringify(s)); } catch {} },
  load:  ()   => { try { const r = localStorage.getItem("bloom:sess"); return r ? JSON.parse(r) : null; } catch { return null; } },
  clear: ()   => { try { localStorage.removeItem("bloom:sess"); } catch {} },
};

export const CustSession = {
  save:  (s)  => { try { localStorage.setItem("bloom:cust", JSON.stringify(s)); } catch {} },
  load:  ()   => { try { const r = localStorage.getItem("bloom:cust"); return r ? JSON.parse(r) : null; } catch { return null; } },
  clear: ()   => { try { localStorage.removeItem("bloom:cust"); } catch {} },
};
